<div *ngIf="apiLoaded | async">
  <div class="map-container">
    <google-map height="100%" width="100%" [zoom]="zoom">
      <map-directions-renderer *ngIf="(directionsResults$ | async) as directionsResults"
        [directions]="directionsResults"></map-directions-renderer>
    </google-map>
  </div>
  <div class="info-box">
    <h1>Trip Details</h1>
    <div class="info-row">
      <div class="info-item">
        <p>Distance (km): {{ distanceInKm }} </p>
      </div>
      <div class="info-item">
        <p>Distance (mi): {{ distanceInMiles }} </p>
      </div>
      <div class="info-item">
        <p>Transit Time: {{ duration }}</p>
      </div>
    </div>
  </div>
</div>